import React, { useState, useEffect } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

export const WorkshopSlider = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      id: 1,
      image: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_think-mechanic/artifacts/ruodkfs4_PHOTO-2026-07-27-11-25-59%203.jpg',
      alt: 'Porsche 911 at Think Mechanic workshop'
    },
    {
      id: 2,
      image: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_think-mechanic/artifacts/8m5lepps_PHOTO-2026-07-27-11-26-01%202.jpg',
      alt: 'Multiple Mercedes C-Class vehicles being serviced'
    },
    {
      id: 3,
      image: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_think-mechanic/artifacts/jss1wh4o_PHOTO-2026-07-27-11-26-01%204.jpg',
      alt: 'Mercedes GLE and C43 AMG workshop service'
    },
    {
      id: 4,
      image: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_think-mechanic/artifacts/qh8znhvl_PHOTO-2026-07-27-11-26-01%205.jpg',
      alt: 'Range Rover vehicles at Think Mechanic'
    },
    {
      id: 5,
      image: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_think-mechanic/artifacts/zps3c0ay_PHOTO-2026-07-27-11-26-02.jpg',
      alt: 'Mercedes G-Wagon AMG and S-Class workshop service'
    }
  ];

  // Auto-advance slides
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 4000); // Change slide every 4 seconds

    return () => clearInterval(interval);
  }, [slides.length]);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  return (
    <div className="relative overflow-hidden rounded-2xl group">
      {/* Slides Container */}
      <div className="relative w-full h-[500px]">
        {slides.map((slide, index) => (
          <div
            key={slide.id}
            className={`absolute inset-0 transition-opacity duration-700 ${
              index === currentSlide ? 'opacity-100' : 'opacity-0'
            }`}
          >
            <img
              src={slide.image}
              alt={slide.alt}
              className="w-full h-full object-cover"
            />
            {/* Gradient Overlay */}
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
          </div>
        ))}
      </div>

      {/* Navigation Arrows */}
      <button
        onClick={prevSlide}
        className="absolute left-4 top-1/2 -translate-y-1/2 bg-white/90 hover:bg-white p-2 rounded-full shadow-lg transition-all opacity-0 group-hover:opacity-100"
        aria-label="Previous slide"
      >
        <ChevronLeft className="w-6 h-6 text-gray-900" />
      </button>
      <button
        onClick={nextSlide}
        className="absolute right-4 top-1/2 -translate-y-1/2 bg-white/90 hover:bg-white p-2 rounded-full shadow-lg transition-all opacity-0 group-hover:opacity-100"
        aria-label="Next slide"
      >
        <ChevronRight className="w-6 h-6 text-gray-900" />
      </button>

      {/* Dots Navigation */}
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex space-x-2">
        {slides.map((_, index) => (
          <button
            key={index}
            onClick={() => goToSlide(index)}
            className={`transition-all duration-300 rounded-full ${
              index === currentSlide
                ? 'w-8 h-2 bg-red-600'
                : 'w-2 h-2 bg-white/60 hover:bg-white'
            }`}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>
    </div>
  );
};
